import React from 'react';
import Header from '../../components/Header';
import LinkList from '../../components/LinkList';

const PrivacyPolicy = ({handleLogoutClick}) => {
  const links = [{
    to: '/help',
    text: 'Help'
  }, {
    to: '/terms-of-service',
    text: 'Terms of Service'
  }];
  
  return(
    <div>
      <Header
        handleLogout={handleLogoutClick}
        title="PRIVACY POLICY" />
      <LinkList linkItems={links}/>
    </div>
  );
}

export default PrivacyPolicy;



/** WEBPACK FOOTER **
 ** ./src/containers/PrivacyPolicy/index.js
 **/